<template>
  <base-layout :title="title || titleName" :hideFooter="false">
      <template slot="main">
          <div class="address-add-page">
              <div class="gap"></div>
              <!-- loading加载状态容器 -->
              <div class="loading-container" v-if="isLoading">
                  <div>
                      <loading type="spinner" size="30px" color="#9c9c9c" />
                      <p>{{ $t('comm.loading') }}</p>
                  </div>
              </div>
              <form v-else>
                  <ul class="addresss-form-list">
                      <li :class="{ err: errors.has('baseAddress') }">
                          <label>{{ $t('newAddAddress.deliveryAddress') }}</label>
                          <div class="address-select-input">
                              <router-link tag="div" to="/address/select" class="location-select-text">
                                  <span class="text-ellipsis">
                                      <em class="dmicon dm-dizhi"></em>
                                      <input type="hidden" :value="baseAddress" name="baseAddress"
                                          v-validate="{ required: true }" />
                                      {{ baseAddress || $t('newAddAddress.clickToChoose') }}
                                  </span>
                                  <i class="dmicon dm-xiangyoujiantou"></i>
                                  <p v-if="illegal">{{ updateText }}</p>
                              </router-link>
                          </div>
                      </li>
                      <li :class="{ err: errors.has('detailAddress') }">
                          <label>{{ $t('newAddAddress.houseNumber') }}</label>
                          <div>
                              <div v-if="form.site" class="site">{{ form.site }} 取餐</div>
                              <input v-else type="text" v-model="form.detailAddress" name="detailAddress"
                                  v-validate="{ required: true, illegal: true, max: 100 }"
                                  :placeholder="$t('newAddAddress.detailAddressEg')">
                          </div>
                      </li>
                      <li :class="{ err: errors.has('consignName') }">
                          <label>{{ $t('newAddAddress.name') }}</label>
                          <div>
                              <input type="text" name="consignName" v-model="form.consignName"
                                  v-validate="{ required: true, nickname: true, max: 16 }"
                                  :placeholder="$t('newAddAddress.inputName')">
                          </div>
                      </li>
                      <li>
                          <label></label>
                          <div>
                              <ui-radio name="sex" :title="$t('newAddAddress.Mr')" v-model="form.sex" value="1" />
                              <ui-radio name="sex" class="radio" :title="$t('newAddAddress.Ms')" v-model="form.sex"
                                  value="2" />
                          </div>
                      </li>
                      <li>
                          <label>{{ $t('newAddAddress.mobile') }}</label>
                          <div :class="{ err: errors.has('consignTel') }">
                              <input type="text" name="consignTel" v-model="form.consignTel"
                                  v-validate="{ required: true, phone: true }"
                                  :placeholder="$t('newAddAddress.inputMobileNumber')">
                          </div>
                      </li>
                  </ul>
              </form>
              <div :class="['auto-address', showAuto ? 'show-auto' : '']">
                  <div @click="showAuto = !showAuto" class="title">
                      {{ $t('newAddAddress.intelligentAddressFilling') }}
                      <i class="dmicon dm-xiangyoujiantou"></i>
                  </div>
                  <div class="auto-main">
                      <textarea :placeholder="$t('newAddAddress.addressAutomaticallyIdentify')" maxlength="256"
                          v-model="form.autoAddress" confirm-type="done" class="textarea"></textarea>
                      <div @click="autoTap" class="clear-btn">
                          <div v-if="form.autoAddress" class="dmicon dm-delete"></div>
                      </div>
                  </div>
                  <div @click="smartRead(form.autoAddress)" class="auto-submit">
                      {{ $t('newAddAddress.submit') }}
                  </div>
              </div>
          </div>
      </template>
      <template slot="footer">
          <div class="address-save" @click="submit">
              <button type="button">
                  <btn-loading :loading="isRequest"
                      :loadingText="(id ? (action == 'update' ? '保存并使用' : '修 改') : '保 存') + '中...'"
                      :text="id ? (action == 'update' ? $t('newAddAddress.saveAndUse') : $t('newAddAddress.edit')) : $t('newAddAddress.add')" />
              </button>
          </div>
      </template>
  </base-layout>
</template>

<script>
import { Toast, Loading, Dialog } from 'vant';
import baseLayout from '@comm/view/layout/baseLayout';
import addressStore, { normalizeUserAddressInfo } from '@comm/store/address.store'
import uiRadio from '@components/radio';
import btnLoading from "@components/comm/btn-loading";
// 订单
import orderStore from '@app/order/_store/order.store';
// 用户存储
import userStore from '@comm/store/user/userInfo.store';
// 门店处理
import storeModel, { getStoreByPoint } from "@comm/store/store.model";
import { getShopping } from "@app/product/_store/shopping";
// 多语言字典
import { address as pageI18n } from "@config/i18n/page/address";

export default {
  name: 'myAddressAdd',
  components: {
      uiRadio,
      Loading,
      baseLayout,
      btnLoading,
  },
  props: {
      id: {
          type: [String, Number],
          default: undefined
      },
      // 页面标题
      title: {
          type: String,
          default: undefined // '新增地址'
      }
  },
  beforeRouteEnter(to, from, next) {
      // 检查是否不是从地址选择返回来的
      if (from.path != '/address/select') {
          // 用户地址新增临时存储
          userStore.state.addAddressTempStore = {};
          // 删除临时地址
          addressStore.commit('clearTempSelectAddress');
      }
      next()
  },
  beforeCreate() {
      // 加载当前页面的i18n字典配置
      this.$loadI18nConfig(pageI18n);
  },
  created() {
      // 个性化message
      this.$validator.localize('zh_CN', {
          custom: {
              consignName: {
                  required: this.$t('validator.nameCannotEmpty'),
                  nickname: this.$t('validator.nameCannotContainSpecialCharacters'),
                  max: this.$t('validator.nameCannot16Characters'),
              },
              detailAddress: {
                  required: this.$t('validator.numberOrAddressCannotEmpty'),
                  illegal: this.$t('validator.numberOrAddressCannotContainCharacters'),
                  max: this.$t('validator.numberCannot100Characters'),
              },
              consignTel: {
                  required: this.$t('validator.phoneCannotEmpty'),
                  phone: () => this.$t('validator.phoneFormatIncorrect'),
              },
              baseAddress: {
                  required: this.$t('validator.addressCannotEmpty'),
                  illegal: this.$t('validator.addressCannotContainCharacters')
              },
          }
      });
      // url参数
      const urlQuery = this.$route.query;
      // 检查是否新增
      if (!this.id && urlQuery.name) {
          this.form.name = urlQuery.name;
          // 根据经纬度获取真实地址
          this.$locationMap.getPointToLocation({
              longitude: urlQuery.lng,
              latitude: urlQuery.lat
          }).then(resInfo => {
              // 临时地址记录
              addressStore.state.tempSelectAddressInfo = addressStore.state.tempSelectAddressInfo || {
                  address: resInfo.address,
                  point: resInfo.point,
                  ...resInfo.addressComponents,
                  name: urlQuery.name,
              };

              this.targetAddress = {
                  ...resInfo,
                  name: urlQuery.name,
                  title: urlQuery.name,
              }
          });
      }
  },
  mounted() {
      // url参数
      const urlQuery = this.$route.query;
      // 检查是否详情
      if (this.id) {
          this.detail(this.id);
      } else {
          this.isLoading = false;
          // 给新增时候添加其他页面携带过来的参数
          Object.keys(this.form).forEach(key => {
              this.form[key] = this.form[key] || userStore.state.addAddressTempStore[key] || urlQuery[key] || ''
          })
          // 避免性别无数据
          this.form.sex = this.form.sex || 1
      }

      // 记录新增的临时地址
      userStore.state.addAddressTempStore = this.form;
  },
  data() {

      // 检查是否不是从地址选择返回来的
      if (this.$fromPath.path != '/address/select') {
          userStore.state.addAddressTempStore = {};
          // 删除临时地址
          addressStore.commit('clearTempSelectAddress');
      }

      return {
          isLoading: true,
          isRequest: false,
          illegal: false,
          action: this.$route.query.action,
          form: {
              // 收货人姓名
              "consignName": "",
              // 收货人电话
              "consignTel": "",
              // 详细地址
              "detailAddress": "",
              // 基础地址
              "baseAddress": "",
              // 性别
              "sex": "",
              // 智能识别地址
              autoAddress: "",
              lat: null,
              lng: null,
              // 特殊商圈地址
              site: "",
          },
          showAuto: false,
          updateText: this.$t('newAddAddress.selectConfirmAddress'),
          titleName: this.$t('addressList.addNewAddress'),
      }
  },
  methods: {
      autoTap() {
          if (this.form.autoAddress) {
              this.form.autoAddress = '';
          }
      },
      //智能识别地址
      smartRead(text) {
          if (!text) return;
          this.$service('smartRead').success(this.checkTextAddress).error(err => {
              Toast(this.$t('hint.unrecognizable'))
          }).send({
              text: text
          })
      },
      checkTextAddress(address) {
          this.form.consignName = address.consignName || this.form.consignName || '';
          this.form.consignTel = address.consignTel || this.form.consignTel || '';

          return Dialog({
              message: this.$t('hint.identificationSuccessConfirmAddress'),
              confirmButtonText: this.$t('hint.makeSure')
          }).then(() => {
              this.$router.push({
                  path: '/address/select',
                  query: {
                      search: address.detailAddress,
                      city: address.city
                  }
              })
          })

          // 调用高德地图接口搜索
          address.detailAddress && address.provinceName && this.$locationMap.getLocationToPoint(address.detailAddress).then(addrInfo => {
              if (addrInfo.point) {
                  getStoreByPoint(addrInfo.point).then(store => {
                      if (store.inRange) {
                          Toast('识别成功');
                          this.form.consignName = address.consignName || '';
                          this.form.consignTel = address.consignTel || '';
                          addrInfo.storeInfo = store;
                          addressStore.commit('setTempSelectAddress', addrInfo);
                          this.$nextTick(() => {
                              Object.assign(this.form, addrInfo.point);
                              this.form.baseAddress = address.baseAddress || '';
                              this.form.detailAddress = /*this.form.detailAddress ||*/ address.detailAddress || '' + address.baseAddress || '';
                          })
                      } else {
                          Dialog({
                              message: `亲，超出外送范围，不能添加！`,
                              confirmButtonText: "重新选择"
                          }).then(() => {

                          })
                      }
                  })
              } else {
                  Toast(this.$t('hint.unrecognizable'))
              }
          }, () => {
              Toast(this.$t('hint.unrecognizable'))
          })
      },
      submit() {
          // 检查是否请求中
          if (this.isRequest) return
          // 字段校验
          this.$validator.validateAll().then(poss => {
              if (poss) {
                  const detail = this.form;
                  // 获取临时地址
                  let tempSelectAddressInfo = addressStore.state.tempSelectAddressInfo || {};
                  // 获取对应的门店(主要用来获取门店code)
                  let storeInfo = tempSelectAddressInfo.storeInfo || { storeCode: this.form.storeCode } || storeModel.getters.targetStoreInfo;
                  // 检查临时数据是否有效
                  if (!Object.keys(tempSelectAddressInfo).length) {
                      tempSelectAddressInfo = {
                          point: {
                              lat: detail.lat,
                              lng: detail.lng,
                          },
                          address: detail.baseAddress,
                          name: detail.name,
                          cityName: detail.cityName,
                          countyName: detail.countyName,
                          provinceName: detail.provinceName,
                      };
                  }

                  // 字段非法字符过滤
                  function filterHandle(str) {
                      return (str || '').replace(/[、|']/g, '');
                  }

                  let sendData = {
                      baseAddress: filterHandle(tempSelectAddressInfo.name),
                      id: this.id,
                      lat: tempSelectAddressInfo.point.lat,
                      lng: tempSelectAddressInfo.point.lng,
                      // 百度地址名称 （后端设定key为name）
                      name: filterHandle(tempSelectAddressInfo.name),
                      // 避免无城市名称
                      cityName: tempSelectAddressInfo.city || (storeInfo.addressComponents || {}).city,
                      countyName: [].concat(tempSelectAddressInfo.district).join(""),
                      provinceName: tempSelectAddressInfo.province,
                      storeCode: storeInfo.storeCode,
                      move: tempSelectAddressInfo.move,
                  }

                  this.form.detailAddress = filterHandle(this.form.detailAddress);

                  // 移除空数据（避免覆盖有效数据）
                  Object.keys(sendData).forEach(function (key) {
                      if (!sendData[key]) delete sendData[key];
                  })

                  // 取餐点数据
                  if (this.form.site) {
                      sendData.pickupPointName = this.form.site;
                      sendData.pickupPointLat = tempSelectAddressInfo.pickupPointLat || this.form.pickupPointLat;
                      sendData.pickupPointLng = tempSelectAddressInfo.pickupPointLng || this.form.pickupPointLng;
                  } else {
                      sendData.pickupPointName = null;
                      sendData.pickupPointLat = null;
                      sendData.pickupPointLng = null;
                  }

                  this.isRequest = true;

                  if (!sendData.lat || !sendData.lng || String(sendData.lat).length <= 5) {
                      this.isRequest = false;
                      return Toast(this.updateText)
                  }

                  this.$service(this.id ? 'updateAddress' : 'addAddress').success(resAddress => {

                      const addressInfo = normalizeUserAddressInfo(resAddress)
                      // 删除临时地址
                      addressStore.commit('clearTempSelectAddress');
                      // 检查是否新增，并检查是否在派送范围内
                      if (!this.id) {
                          // 设置为派送地址、并标注数据是新增，主要提供给提交订单页面使用
                          addressInfo.isAdd = true;
                      }

                      // 检查当前修改的地址是否已选的地址
                      if (addressStore.state.harvestAddressInfo && addressStore.state.harvestAddressInfo.id == addressInfo.id) {
                          // 设置送餐地址
                          addressStore.commit('setHarvestAddressInfo', addressInfo);
                      }

                      // 地址信息
                      const { consignName, sex, detailAddress, baseAddress, consignTel } = addressInfo.originInfo;

                      // CDP 地址新增埋点  [新增地址]
                      if (!this.id) {
                          this.$CDP.track('c_addaddress', {
                              // 送餐地址
                              c_address: baseAddress,
                              // 门牌号
                              c_number: detailAddress,
                              // 联系人
                              c_name: consignName,
                              // 联系人性别
                              c_gender: sex == 1 ? '男士' : '女士',
                              // 收餐人手机
                              c_phone: consignTel,
                          })
                      }

                      // 新增地址
                      if (this.action == 'update' || !this.id) {
                          // 设置收餐地址
                          addressStore.commit('setHarvestAddressInfo', addressInfo);
                          // 通过经纬度获取门店信息
                          return getStoreByPoint(addressInfo.point).then(storeInfo => {
                              // 设置门店
                              storeModel.commit('setSelectStoreInfo', storeInfo);
                              // 订单类型或订单时间检查接口
                              orderStore.dispatch('orderReservation', { serviceMethod: storeInfo.inRange ? 0 : 1 }).then(() => {
                                  // 进行页面跳转
                                  if (this.$route.query.name) {
                                      this.$router.go(-2)
                                      // 设置目标地址信息
                                      addressStore.commit('setHarvestAddressInfo', this.targetAddress);
                                  } else {
                                      this.$router.back();
                                  }
                                  return Toast.success({
                                      duration: 1000,
                                      message: this.id ? '修改成功！' : '添加成功！'
                                  });
                              });

                          });

                      }

                      // 返回上一个页面
                      this.$router.back();

                      Toast.success({
                          duration: 1000,
                          message: this.id ? '修改成功！' : '添加成功！'
                      });

                  }).error((err, option) => {
                      this.isRequest = false;
                      const xhr = option.xhr || {};
                      let { errCode, errMsg, data } = JSON.parse(xhr.responseContent || '{}');
                      // 敏感字符
                      if (errCode == 400241) {
                          // 数据回显
                          this.form.id = data.id;
                          this.form.consignName = data.consignName;
                          this.form.detailAddress = data.detailAddress;
                          // 敏感词提示
                          /*Dialog.confirm({
                              message: `<p style="white-space: pre-line;text-align: left;">${errMsg}</p>`,
                              showCancelButton: true,
                              showConfirmButton: true,
                              confirmButtonText: '去修改',
                              cancelButtonText: '不修改',
                          }).then(() => {
                              // 去修改停留在当前页面
                          }, () => {
                              // 不修改直接返回
                              this.$router.back();
                          })*/


                          // CDP埋点 [地址管理页敏感词后弹窗记录]
                          this.$CDP.track('c_sensitive_address', {
                              c_buttonName: this.$route.query.id ? '地址修改' : '新增地址'
                          })

                          // 检查是否新增页面
                          if (!this.$route.query.id) {
                              this.jumpHint(true);
                              // 新增页面返回上一页
                              this.$router.back();
                          }

                          Toast(err)

                      }else if( errCode == 400246 || errCode == 400247){
                          Dialog.alert({
                              confirmButtonText: "重新选择",
                              message: err || errMsg,
                          }).then(() => {
                              this.$router.push('/address/select')
                          });

                      } else {
                          Toast(err)
                      }
                  }).send(Object.assign({}, this.form, sendData, { sex: Number(this.form.sex) }))
              } else {
                  // 提取错误信息
                  let errField = this.$validator.errors.items[0];
                  Toast(errField.msg)
              }
          })
      },
      // 地址详情
      detail(id) {
          addressStore.dispatch('getDetailAddress', id).then(addressInfo => {
              this.isLoading = false;
              // 数据回显
              this.form = addressInfo.originInfo;
              this.form.site = addressInfo.originInfo.pickupPointName || "";
              // 标识地址合法性
              // 如果已经选择了地址则移除不合法标识
              if (addressStore.state.tempSelectAddressInfo) {
                  this.illegal = !addressStore.state.tempSelectAddressInfo.address;
              } else {
                  this.illegal = addressInfo.illegal;
              }
          }, errMsg => {
              if (errMsg === "登录已失效,请重新登录" || errMsg === "登录过期!") return
              this.isLoading = false;
              return Dialog.alert({
                  confirmButtonText: this.$t('comm.back'),
                  message: `<p style="white-space: pre-line;text-align: left;">${this.$t('newAddAddress.addressHasBeenDeleted')}</p>`,
              }).then(() => {
                  this.$router.back();
              });
          })
      }
  },
  computed: {
      baseAddress() {
          let addresssInfo = addressStore.state.tempSelectAddressInfo || {};
          this.form.detailAddress = addresssInfo.address || this.form.detailAddress;
          this.form.site = addresssInfo.hasOwnProperty('site') ? addresssInfo.site : this.form.site;
          return addresssInfo.name || this.form.baseAddress || this.form.name || '' //|| addresssInfo.city + addresssInfo.district + addresssInfo.title || ''
      }
  }
}
</script>

<style lang="scss" scoped>
@import "~@assets/style/app/var.scss";

.radio {
  margin-left: 20px;
}

.base-layout-body {
  padding-bottom: 55px !important;
}

/deep/ .base-layout-footer {
  height: 55px !important;
}

.address-save {
  padding: 0 20px;
  width: 100%;
  border: none;

  button {
      width: 100%;
      height: 45px;
      color: white;
      font-size: 16px;
      border: none;
      border-radius: 5px;
      outline: none;
      background-color: rgba(255, 46, 46, 1);
      background: linear-gradient(to right,
              rgba(255, 98, 67, 1) 0%,
              rgba(255, 46, 46, 1) 100%);

      /deep/ span {
          font-size: 16px;
      }
  }
}

.address-add-page {
  height: 100%;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
}

.gap {
  background-color: $pageBg;
  padding-top: 10px;
}

.address-select-input {
  position: relative;

  p {
      left: 20px;
      bottom: -16px;
      color: red;
      position: absolute;
      font-size: 12px;
      transform: scale(0.9);
  }
}

.addresss-form-list {
  padding: 10px 20px;

  li {
      display: flex;
      height: 60px;
      align-items: center;

      >label {
          width: 65px;
          font-size: 14px;
          font-weight: 600;
      }

      >div {
          flex: 1;
          height: 100%;
          display: flex;
          align-items: center;
      }

      input {
          height: 70%;
          width: 100%;
          border: none;
          outline: none;
          padding-left: 10px;
          background: #f9fafc;
          border-radius: 5px;

          &::placeholder {
              color: #b7b7b7;
              padding-left: 5px;
          }
      }

      .site {
          height: 70%;
          width: 100%;
          border: none;
          outline: none;
          padding-left: 10px;
          background: #f9fafc;
          border-radius: 5px;
          display: flex;
          align-items: center;
      }

  }
}

.location-select-text {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  em {
      font-size: 18px;
      padding-right: 5px;
  }

  span {
      color: gray;
      display: flex;
      padding-right: 1px;
      align-items: center;
  }
}

.loading-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  >div {
      height: 200px;
      display: flex;
      align-items: center;
      flex-direction: column;
  }

  p {
      color: #9c9c9c;
      font-size: 14px;
      padding-top: 20px;
      text-align: center;
  }
}

.auto-address {
  width: 100%;
  height: 26px;
  padding: 0 18px;
  background-color: #f2f2f2;
  overflow: hidden;
  transition: all 0.3s;

  &.show-auto {
      height: 144px;

      .dm-xiangyoujiantou {
          transform: rotate(-90deg) !important;
      }
  }

  .title {
      display: flex;
      width: 100%;
      height: 26px;
      font-size: 12px;
      color: #ff4031;
      align-items: center;

      .dm-xiangyoujiantou {
          font-size: 14px;
          font-weight: 700;
          color: #333;
          margin-left: auto;
          transition: all 0.3s;
          transform: rotate(90deg);
      }
  }

  .auto-main {
      display: flex;
      width: 100%;
      height: 72px;
      background-color: #fff;
      border-radius: 8px;
      align-items: center;
      overflow: hidden;

      .textarea {
          width: 84%;
          height: 100%;
          padding: 8px 12px;
          font-size: 12px;
          color: #333;
          border: none;
          outline: none;
          resize: none;
      }

      .clear-btn {
          display: flex;
          flex: 1;
          height: 70%;
          justify-content: center;
          align-items: center;
          border-left: 1px solid #999;
          padding-right: 3px;

          .text {
              font-size: 14px;
              color: #ff4031;
          }

          .dm-delete {
              font-size: 16px;
              color: #999;
          }
      }
  }

  .auto-submit {
      display: flex;
      width: 68px;
      height: 22px;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #fff;
      border-radius: 14px;
      background-color: #ff4031;
      margin: 10px;
      margin-left: auto;
  }
}
</style>